import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function accessReducer(state = initialState.access, action) {
  switch (action.type) {
    case types.CAN_I_ACCESS_SUCCESS:
      return action.data;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/accessReducer.js